import { render, staticRenderFns } from "./CustomerTabOverview.vue?vue&type=template&id=0c85f54c&scoped=true&"
import script from "./CustomerTabOverview.vue?vue&type=script&lang=js&"
export * from "./CustomerTabOverview.vue?vue&type=script&lang=js&"
import style0 from "./CustomerTabOverview.vue?vue&type=style&index=0&id=0c85f54c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c85f54c",
  null
  
)

export default component.exports